module.exports = __webpack_public_path__ + "assets/images/aldeao_c57df0a23b69b9e30be5b8f546967cb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tela-de-desafio/icons/aldeao.png
// module id = 185
// module chunks = 0